import * as React from "react";
import { clsx } from "clsx";
import { useFormContext } from "react-hook-form";

export type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  label: string;
  name: string;
  required?: boolean;
};

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      className,
      type,
      label,
      value,
      onChange,
      required,
      name = "name",
      ...props
    },
    ref
  ) => {
    const inputId = `${label.replace(" ", "")}-${type}`;
    const {
      register,
      formState: { errors },
    } = useFormContext();

    return (
      <div className="mx-auto w-full mb-6">
        <label
          htmlFor={inputId}
          className="block text-md font-bold text-gray-700 dark:text-white"
        >
          {label} <span className="text-red-700">{required ? "*" : null}</span>
        </label>
        {errors[name] && (
          <span className="text-red-700">{"This field is required."}</span>
        )}

        <input
          type={type}
          id={inputId}
          value={value}
          role="input"
          data-cy-input={name}
          aria-label={label}
          // onChange={onChange}
          className={clsx(
            "form-input w-full rounded border border-stroke px-[14px] text-base text-body-color outline-none focus:border-primary dark:border-dark-3 dark:bg-gray-900 dark:text-dark-6",
            className
          )}
          // ref={ref}
          {...register(name, {
              setValueAs: (value) => type == 'number' ? parseFloat(value) || 0: value,
            required: required,
          })}
          {...props}
        />
      </div>
    );
  }
);

Input.displayName = "Input";

export default Input;
